import type { User } from '@/types/api';
import { isNative } from '@/lib/platform';

/**
 * Canonical home path for a given role. Single source of truth for both the
 * route guards (App.tsx) and post-auth redirects (AuthContext) so a freshly
 * logged-in user always lands on their role's home — e.g. an applicant goes to
 * the application wizard, NOT the parent dashboard.
 *
 * TRFers get the lightweight mobile surface (/trfer/m) on native and the full
 * desktop surface (/trfer) on web.
 */
export function homeFor(role: User['role'] | undefined): string {
  if (role === 'admin') return '/admin';
  if (role === 'trfer') return isNative() ? '/trfer/m' : '/trfer';
  if (role === 'applicant') return '/apply/wizard';
  return '/dashboard';
}
